import { render } from "./DriversChart.vue?vue&type=template&id=00b2ad06"
import script from "./DriversChart.vue?vue&type=script&lang=js"
export * from "./DriversChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__